import { createScreener } from '@/utils/screener'
import { request } from '@/utils/request.js'
import { packCriteria } from '@/utils/filters'

export const FIELDS = {
    cik: 'CIK',
    name: 'Name',
    createdDate: 'Imported At',
}

export function getFiler(cik, signal = null) {
    return request.get(`/api/providers/sec/filers/${cik}`, null, { signal })
}

async function searchFilers(criteria, page, sort, facets, signal) {
    const { content } = await request.post(
        '/api/providers/sec/filers/search',
        {
            criteria: packCriteria(criteria),
            facets,
            ...page,
            sortField: sort?.field ?? null,
            sortDirection: sort?.direction ?? null,
        },
        { signal }
    )

    return content
}

export function createFilersScreener(options = {}) {
    return createScreener(searchFilers, 'filers', options)
}
